import styled from 'styled-components/macro';
import EntityItem from 'components/base/EntityItem/EntityItem';
import Cell from 'components/data-visualization/Table/Cell';
import SearchFieldRaw, {
  SearchFieldContainer as SearchFieldContainerRaw,
} from 'components/styled/SearchField/SearchField';

import { ReactComponent as ToggleCaret } from 'icons/icon-toggle-caret.svg';

export const Caret = styled(ToggleCaret)<any>`
  color: #fff;
  margin-left: 8px;

  transform: rotate(${({ open }): string => (open ? '0' : '180deg')}) scale(0.7);
  transition: transform 300ms linear;
`;

export const CaretBack = styled(ToggleCaret)<any>``;

export const Wrapper = styled('div')<any>``;

export const Button = styled('div')<any>`
  color: #fff;
  font-size: 13px;
  line-height: 15px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 40px;
  height: 25px;
  padding: 5px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background: rgba(255, 255, 255, 0.14);
  }
`;

export const ModalWrapper = styled('div')<any>`
  background: #fff;
  max-height: 575px;
  position: absolute;
  top: 71px;
  min-width: 500px;
  max-width: 550px;
  min-height: 50px;
  max-height: 570px;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 18%);
  overflow: scroll;
  padding: 18px 22px 8px 26px;
  margin-left: ${({ marginLeft }): string => (marginLeft ? marginLeft : '0')};
`;

export const StyledEntityItem = styled(EntityItem)`
  padding: ${({ theme }): string => theme.spacing.small} 0 0;

  @media screen and (min-width: 50em) {
    padding: ${({ theme }): string => theme.spacing.small} 0;
  }

  &:active,
  &:hover {
    background: none;
  }
`;

export const NumVersionCell = styled(Cell)`
  background: #fff;
  border-bottom: 1px solid rgb(232, 235, 237);
`;

export const EntityCell = styled(Cell)`
  background: #fff;
  border-bottom: 1px solid rgb(232, 235, 237);

  &:hover,
  &:focus {
    background: ${({ theme }): string => theme.Sand};
  }

  &:active {
    background: ${({ theme }): string => theme.LightGrey};
  }
`;

export const VersionsButton = styled('div')<any>`
  background: #fff;
  color: #0bd6a7;
  border: 1px solid #0bd6a7;
  box-sizing: border-box;
  border-radius: 40px;
  font-size: 13px;
  line-height: 15px;
  white-space: nowrap;
  height: 25px;
  padding: 5px 9px 5px 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-right: ${({ marginRight }): string =>
    marginRight ? marginRight : '0'};

  &:active,
  &:hover {
    background: #0bd6a7;
    color: #fff;
  }
`;

export const ButtonBack = styled('div')<any>`
  color: #0bd6a7;
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;
  margin: 5px 0 25px;
  display: flex;
  align-items: center;
  width: fit-content;

  svg {
    transform: rotate(90deg) translateY(-2px);
    transition: transform 300ms linear;
  }
  &:active,
  &:hover {
    svg {
      transform: rotate(90deg) translateY(2px);
    }
  }
`;

export const SearchField = styled(SearchFieldRaw)``;

export const SearchFieldContainer = styled(SearchFieldContainerRaw)`
  background: #f9f9fa;
  border-radius: 71px;
  border: 1px solid #e8ebed;
  padding: 0.2em 1em 0.2em 1em;
  label {
    background: #f9f9fa;
    margin-top: 15px;
    width: 100%;
    max-height: 41px;
  }
`;

export const VersionText = styled('div')`
  font-size: 13px;
  line-height: 28px;
  letter-spacing: 1px;
  color: #8ea6be;
  margin-left: 3px;
  display: flex;
  align-items: center;
`;

export const CaretVersions = styled(ToggleCaret)<any>`
  transform: rotate(270deg) translateY(3px) scale(0.7);
`;
